import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import SentimentPollDetails from './SentimentPollDetails';

const SentimentPoll = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(sentimentpoll|sentimentpoll/start)"
                            name="SentimentPollDetails"
                            exact
                            component={SentimentPollDetails}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default SentimentPoll;



// WEBPACK FOOTER //
// ./src/containers/SentimentPoll/SentimentPoll.jsx